import { DropzoneOptions, FileError } from 'react-dropzone'
import { match } from 'ts-pattern'

import { ERROR_CODE_MESSAGES, IMAGE_FILE_TYPES } from '../../constants'
import { DocumentTypeOption, ErrorCode, TrackedFile } from '../../types'
import { defaultDropzoneConfig, offerLetterDropzoneConfig } from './constants'

export function duplicateFileValidator({
  file,
  files,
}: {
  file: File
  files: TrackedFile[]
}): FileError | FileError[] | null {
  const duplicateFile = files.find((f) => f.file?.name === file.name)

  if (duplicateFile) {
    return {
      code: ErrorCode.DUPLICATE_FILE,
      message: ERROR_CODE_MESSAGES()[ErrorCode.DUPLICATE_FILE],
    }
  }

  return null
}

export function getIsUnsupportedImageType(file: File): boolean {
  const fileName = file.name
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase()
  const isExtensionValid = IMAGE_FILE_TYPES.includes(extension)

  const mimeType = file.type
  const mimeSubtype = mimeType.startsWith('image/') ? mimeType.split('/')[1] : ''
  const isMimeValid = IMAGE_FILE_TYPES.includes(`.${mimeSubtype}`)

  return !(isExtensionValid || isMimeValid)
}

export function getDropzoneConfigForDocumentType(documentType: DocumentTypeOption | null): Partial<DropzoneOptions> {
  return match(documentType)
    .with(DocumentTypeOption.OFFER_LETTER, () => offerLetterDropzoneConfig)
    .otherwise(() => defaultDropzoneConfig)
}
